<template>
  <CommunityCategoryPage
    :items="asyncData?.allPosts || []"
    :title="title"
    :post-type="postType"
    :category="asyncData?.category"
  />
</template>

<script setup lang="ts">
import { metaGen } from '~/util/metadata';
import { fetchCommunityCategory } from '~/util/contentstack/community';
import { useRootStore } from '~/store';
import { CTSPostType } from '~/types/contentstack';

const { $bus }: any = useNuxtApp();
const rootStore = useRootStore();
const params = useRoute()?.params;
const postType = params?.postType as CTSPostType;
const categorySlug = params?.category as string;
const { locale } = useI18n();
const title = postType === 'blog' ? 'Blog' : postType === 'event' ? 'Events' : 'Videos'; // TODO  - update

const event = useRequestEvent();

const { data: asyncData, error: asyncError } = await useAsyncData(async () => {
  const { allPosts, fetchRes, category } = await fetchCommunityCategory({
    postType,
    slug: categorySlug,
    query: {
      locale: locale?.value,
    },
    event,
  });
  if (!allPosts) throw createError({ statusCode: 404, message: 'Page not found' });

  return {
    allPosts,
    fetchRes,
    category,
  };
});

useAsyncErrorHandling({
  error: asyncError.value,
  sentryWanted: false,
});

onMounted(() => {
  $bus.emit('pageView', {
    url: document.URL,
  });
});

const seo = asyncData.value?.category?.seo;
if (seo) {
  useHead({
    ...(metaGen(rootStore?.brandSettings, {
      ...(seo || {}),
    }) as any),
  });
} else {
  useHead({
    ...(metaGen(rootStore?.brandSettings, {
      page_title: `Community ${postType.toUpperCase()}`,
      page_description:
        'Blogs, Videos, Events, and Livestreams! - Recipes, stories, product information, how-to, and more!',
    }) as any),
  });
}
</script>
